import { render, staticRenderFns } from "./LenonDropdownItem.vue?vue&type=template&id=1aedbfe8&scoped=true&"
import script from "./LenonDropdownItem.vue?vue&type=script&lang=js&"
export * from "./LenonDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aedbfe8",
  null
  
)

export default component.exports